<template>
  <div>
    <Loading v-if="loading" />
    <BaseConfirm
      icon-type="badge"
      title="Hapus Wilayah Harga"
      message="Apakah anda yakin ingin menghapus wilayah harga ini?"
      :visible="visible"
      @close="$emit('close')"
      @confirmed="onConfirm"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { requestMixin } from '../../../../mixins/request/request';
import BaseConfirm from '../../../base/BaseConfirm.vue';

export default {
  mixins: [requestMixin],
  props: {
    visible: Boolean,
    id: String,
  },
  emits: ['close', 'deleted'],
  components: { BaseConfirm },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async onConfirm() {
      this.loading = true;

      const [, err] = await this.request(`/api/v1/order-routes/${this.id}`, {
        method: 'delete',
      });

      if (!err) {
        this.createAlert({
          status: 'success',
          data: 'Data berhasil dihapus',
        });

        this.$emit('close');
        this.$emit('deleted');
      }

      this.loading = false;
    },
  },
};
</script>
